<template>
    <div class="w-100">
        <div v-if="isDropdown" class="w-100">
            <Multiselect
                v-model="selectedDepartments" 
                :options="departmentsList"
                track-by="_id"
                label="name"
                :close-on-select="true"
                :show-no-results="false"
                :placeholder="globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?'Select '+globalSettingsFromStartup.department_alias.alias_name:'Select Department'"
                deselectLabel=""
                selectLabel=""
                selectedLabel=""
                @select="emitTheSelectedDepartment()"
                :hideSelected="false"
                :showNoOptions="false">
                <span slot="noResult">No results</span>
                <span slot="noOptions" style="display:none"></span>
                <!-- <div slot="tag" slot-scope="option" class="selected-tags-style"> -->
                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                    <!-- <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeProjectFilterCheckboxAction(scope.option)" @focus.prevent :key="scope.option.name"/> -->
                    <div v-if="Object.keys(scope.option).includes('logo') && !['undefined',null].includes(scope.option.logo) && scope.option.logo" class='logo-or-image'>
                        <img :src="getProxyConvertedURL(scope.option.logo)" @error="(e) => replaceByDefaultImage(e,null)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px;margin-bottom: 5px">
                        <!-- @error="replaceWithUserIcon($event,scope.option.username)" -->
                    </div>
                    <!-- <div v-else>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16" style="color: #4e4e4e;margin-inline-start:4px">
                            <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
                            <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z"/>
                        </svg>
                    </div> -->
                    <span>{{ scope.option.name }}</span>
                </div>
            </Multiselect>
        </div>
        <div v-if="isMultiselectDropdown" class="w-100">
            <Multiselect
                v-model="selectedMultipleDepartments" 
                :options="departmentsList"
                :multiple="true"
                track-by="_id"
                label="name"
                :close-on-select="true"
                :show-no-results="false"
                :placeholder="globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?'Select '+globalSettingsFromStartup.department_alias.alias_name:'Select Department'"
                deselectLabel=""
                selectLabel=""
                selectedLabel=""
                :hideSelected="false"
                :showNoOptions="false"
                @remove="removeSelectetProjectFilterFromSelectedList($event)"
                @select="selectProjects($event)">
                <span slot="noResult">No results</span>
                <span slot="noOptions" style="display:none"></span>
                <div slot="tag" slot-scope="option" class="selected-tags-style">
                <div v-if="Object.keys(option.option).includes('logo') && !['undefined',null].includes(option.option.logo) && option.option.logo" class='logo-or-image'>
                    <img :src="getProxyConvertedURL(option.option.logo)" @error="(e) => replaceByDefaultImage(e,null)"  style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px;margin-bottom: 5px">
                </div>
                <div class="tags-display-style">{{option.option.name}}</div>
                    <div class="remove-tag" v-on:click="removeSelectetProjectFilterFromSelectedList(option.option)">
                        <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </div>
                </div>
                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeProjectFilterCheckboxAction(scope.option)" @focus.prevent :key="scope.option.name"/>
                <div v-if="Object.keys(scope.option).includes('logo') && !['undefined',null].includes(scope.option.logo) && scope.option.logo" class='logo-or-image'>
                    <img :src="getProxyConvertedURL(scope.option.logo)" @error="(e) => replaceByDefaultImage(e,null)"  style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px;margin-bottom: 5px">
                    <!-- @error="replaceWithUserIcon($event,scope.option.username)" -->
                </div>
                <!-- <div v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16" style="color: #4e4e4e;margin-inline-start:4px">
                        <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
                        <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z"/>
                    </svg>
                </div> -->
                <span>{{ scope.option.name }}</span>
                </div>
            </Multiselect>
        </div>
        <div v-if="inWorkspace" class="w-100 d-flex pl-1" style="flex-wrap: wrap;justify-content: flex-start;">
            <div class="projects-display-styles-in-workspace" @click="updatedselectedProjectInWorkspace({'name':'All','_id':'all'})" :class="{activeProject: selectedIds.includes('all')}">All</div>
            <div v-for="project in departmentsList" :key="project._id+project.name"  @click="updatedselectedProjectInWorkspace(project)" :class="{activeProject: selectedIds.includes(project._id)}" class="projects-display-styles-in-workspace">
                <span v-if="'logo' in project && project.logo" class="img-span"><img :src="getProxyConvertedURL(project.logo)" @error="(e) => replaceByDefaultImage(e,null)"/></span>
                {{project.name}}</div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {mapActions,mapMutations, mapGetters} from "vuex";
import {NotifierConstants} from "../../components.constants.js";
import Utils from '../../components.utils';

export default {
    props:['selectedProject','isMultiselectDropdown','isDropdown', 'inWorkspace','inEditMode',"updateDepartments"],
    data(){
        return {
            selectedDepartments:[],
            selectedMultipleDepartments:[],
            departmentsList:[],
            departmentsListForMultiselect:[],
            selectedProjectInWorkspace:'All',
            selectedIds:['all']
        }
    },
    components:{
        "Multiselect":Multiselect,
    },
    methods: {
        updatedselectedProjectInWorkspace(value){
            if(this.selectedIds.length && this.selectedIds.includes(value._id)){
                if(value._id == 'all'){
                    this.selectedIds = [];
                    this.selectedIds.push('all')
                }else{
                    this.selectedIds = this.selectedIds.filter(e => e != value._id);
                    if(this.selectedIds.length == 0){
                        this.selectedIds.push('all')
                    }
                }
            }else{
                 if(value._id == 'all'){
                    this.selectedIds = [];
                    this.selectedIds.push('all')
                }else{
                    this.selectedIds = this.selectedIds.filter(e => e != 'all')
                    this.selectedIds.push(value._id)
                }
            }
            this.$emit("updatedSelectedProjectsArr",this.selectedIds);
            let query = Object.assign({},this.$route.query)
            query['projects'] = JSON.stringify(this.selectedIds)
            this.$router.push({
                "query": query
            })
            Utils.setLocalStorageValue('selectedDepartmentsArr', JSON.stringify(this.selectedIds))
            this.selectedProjectInWorkspace = value;
        },
        replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        emitTheSelectedDepartment(){
            this.$emit("updateSelectedDepartments",this.selectedDepartments)
        },
        selectProjects(selectedOption){
            let index = this.departmentsList.findIndex(item => item._id == selectedOption._id);
            if(index > -1){
                this.departmentsList[index].checked = true;
                this.$emit("updateSelectedDepartments",this.selectedMultipleDepartments)
            }
        },
        makeProjectFilterCheckboxAction(option){
            if(this.selectedMultipleDepartments)
            return this.selectedMultipleDepartments.some((op) => op._id === option._id);
        },
        removeSelectetProjectFilterFromSelectedList(selectedOption){
            this.selectedMultipleDepartments = this.selectedMultipleDepartments.filter(e => e._id != selectedOption._id);
            this.$emit("updateSelectedDepartments",this.selectedMultipleDepartments)
        },
        handleDepartmentNotifications(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            let departmentInfo = notification.message
            if(departmentInfo){
                if(notification.message_type == NotifierConstants.departmentCreated){
                    if(this.inWorkspace && this.isDropdown && this.getLoggedInUserType == 'SystemAdmin'){
                        this.departmentsList.push(departmentInfo)
                    }else if(this.isMultiselectDropdown){
                        this.departmentsList.push(departmentInfo)
                    }
                }
                if(notification.message_type == NotifierConstants.departmentUpdated){
                    let indx = this.departmentsList.find(op=>op._id == departmentInfo._id);
                    if(indx){
                        indx.name = departmentInfo.name;
                        indx.logo = departmentInfo.logo;
                    }
                }
                if(notification.message_type == NotifierConstants.departmentDeleted){
                    this.departmentsList = this.departmentsList.filter(op=>op._id != departmentInfo._id);
                }
            }  
        },
        getOnlyIdsArr(arrayOfDictionaries){
            return arrayOfDictionaries.map(item => item._id);
        },
        getAllDepartmentsList(){
            return this.getOnlyIdsArr(this.departmentsList);
        },
        registerforWebsocketNotifications(){
            this.addWSEventListener({eventname:[NotifierConstants.departmentCreated, NotifierConstants.departmentUpdated, NotifierConstants.departmentDeleted], callback:this.handleDepartmentNotifications,parent:"TagMetadata"})
        },
        unRegisterforWebsocketNotifications(){
            this.removeWSEventListener({eventname:[NotifierConstants.departmentCreated, NotifierConstants.departmentUpdated, NotifierConstants.departmentDeleted], callback:this.handleDepartmentNotifications,parent:"TagMetadata"})
        },
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapActions("miscellaneous", ["getDepartments","createDepartment","updateDepartmentInfo","deleteDepartment","getPermittedDepartmentsOfLoggedInUser"]),
    }, 
    created(){
        if(this.inWorkspace || this.isDropdown){
            this.getPermittedDepartmentsOfLoggedInUser().then((data) => {
                this.departmentsList = data.department;
            })
        }else{
            this.getDepartments().then((data) => {
                this.departmentsList = data.department;
            })
        }
        this.registerforWebsocketNotifications()
        if(this.selectedProject){
            this.selectedDepartments = this.selectedProject;
            this.selectedMultipleDepartments = this.selectedProject;
        }
        if(Utils.getLocalStorageValue('selectedDepartmentsArr')){
            this.selectedIds = JSON.parse(Utils.getLocalStorageValue('selectedDepartmentsArr'))
        }
    },
    computed:{
        globalSettingsFromStartup:{
          get(){
            return this.$store.state.startUpData.startUpDataDetails;
          }
        },
        ...mapGetters("users",["getLoggedInUserType"]),
    },
    watch:{
        selectedProject(newVal){
            if(newVal){
                this.selectedDepartments = newVal;
                this.selectedMultipleDepartments = newVal;
            }
        },
        updateDepartments(newVal){
            if(newVal){
                if(this.inWorkspace){
                    this.getPermittedDepartmentsOfLoggedInUser().then((data) => {
                        this.departmentsList = data.department;
                        if(this.departmentsList.length == 0){
                            this.selectedIds = ['all'];
                            this.$emit("updatedSelectedProjectsArr",this.selectedIds);
                            let query = Object.assign({},this.$route.query)
                            query['projects'] = JSON.stringify(this.selectedIds)
                            this.$router.push({
                                "query": query
                            })
                            Utils.setLocalStorageValue('selectedDepartmentsArr', JSON.stringify(this.selectedIds))
                        }
                    })
                }
                this.$emit("unsetUpdateDepartmentsFlag")
            }
        },
        "$route.fullPath":function(newVal,oldVal){
            if (newVal!=oldVal){
                let query = this.$route.query;
                if(query.projects && query.fromchild){
                    this.selectedIds = [query.projects];
                    Utils.setLocalStorageValue('selectedDepartmentsArr', JSON.stringify(this.selectedIds))
                }
            }
        }
    },
    beforeDestroy(){
        this.unRegisterforWebsocketNotifications();
    }
}
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
$border-color: 1px solid #4a4a4a;
$border-color-only:#4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$none-text-color:#4f4f4f;
$input-field-padding:.375rem 10px;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555;
$tags-background-color:#282d31;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$metadata-border-color-on-hover: #5a5a5a;
$readOnly-bg-color: #1e2326 !important;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;

.logo-or-image{
    height: 30px;
    width: 40px;
    text-align: center;
    // line-height: 28px;
    text-transform: uppercase;
    // margin-top: 3px;
    margin-inline-end: 5px;
    img{
        object-fit: contain;
    }
}

span.img-span{
width: 40px;
height: 40px;
display: inline-block;
padding: 0px;
    img{
        max-width: 100%;
        max-height: 100%;
        border-radius: 4px;
        object-fit: contain;
        display: inline-block;
    }
}  

::v-deep{
    .multiselect__tags-wrap{
        display:flex;
        flex-wrap:wrap;
    }

    .multiselect__placeholder {
        margin-bottom: 4px;
    }
    .multiselect__tag {
        background-color: $primary-background !important;
      }
      .multiselect__tags{
          background: $primary-background;
          border: $border-color;
          padding-bottom:6px;
      }
      .multiselect__option--highlight {
          background: $bg-color-on-hover !important;
      }
      .multiselect__content {
          background: $secondary-background-color !important;
      }
      .multiselect__input, .multiselect__single {
          background: transparent !important;
          color:$text-color;
      }
      .multiselect__tag-icon{
         color:$text-color !important;
      }
      .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
          background: $bg-color-on-hover;
          color: $text-color !important;
      }
      .multiselect__tag-icon:after{
         color:$secondary-text-color !important;
         font-size: 23px;
      }
      .multiselect *{
          font-size: $input-field-and-label-font-size !important;
          font-family: "Roboto", Arial, sans-serif !important;
      }
      .multiselect{
        color:$text-color !important;
        font-size: $input-field-and-label-font-size !important;
        width:100%;
      }
      .multiselect__option--selected{
          background:  $bg-color-on-hover !important;
          color: $text-color;
      }
      .multiselect__content-wrapper{
          border: 1px solid  $bg-color-on-hover !important;
      }
  
      .multiselect__content-wrapper {
      position: absolute;
      display: block;
      background: #fff;
      width: 100%;
      max-height: 240px;
      overflow: auto;
      border: 1px solid #e8e8e8;
      border-top: none;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      z-index:9999999 !important;
      }
      .multiselect__select,.multiselect__current,.multiselect__option{
          line-height: 12px !important;
      }
      .multiselect--above .multiselect__content-wrapper{
         background: $secondary-background-color !important;
      }
      .multiselect__tags {
          background: $primary-background;
      }
      .multiselect__input:focus{
        outline:none;
        box-shadow: none;
      }
  
  .video-js {
  height:100% !important;
  width:680px !important;
  }
  
  }

  input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: -3px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
  }
  input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
  }
  
  
  .selected-tags-style{
    background: $bg-color-on-hover;
    border: 1px solid #363636;
    border-radius: 15px;
    font-size: 12px !important;
    min-height: 25px !important;
    display: inline-flex !important;
    margin: 2px !important;
    border-radius: 15px !important;
    min-width: 50px !important;
    padding: 0px !important;
    text-align: center;
    width: auto !important;
    padding-inline-start: 12px !important;
    justify-content: center;
    padding-top: 2px !important;
    padding-inline-end: 4px !important;
    margin-bottom: 4px !important;
    align-items: center;
    .remove-tag{
        line-height:18px;
        color: #858585;
    }
    }

    .projects-display-styles-in-workspace{
        border:$border-color;
        padding:9px;
        margin: 5px 5px;
        border-radius:7px;
        .img-span{
            height:22px !important;
        }
    }

    .activeProject{
        border: 1px solid $active-blue !important;
        color: $active-blue !important;
    }

    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }
  
</style>